import { connect } from 'react-redux';

import Errors from '../Errors';
import selectors from '../../selectors';

function GlobalErrorHandler({ globalError = null, children = null }) {
  if (!globalError) {
    return children;
  }

  return <Errors globalError={globalError} />;
}

const mapStateToProps = (state) => ({
  globalError: selectors.globalError.get(state),
});

export default connect(mapStateToProps)(GlobalErrorHandler);
